export default __webpack_public_path__ + "static/media/AmazonBasics.8fc7bbf3.jpg";